/**
 * LoadingSpinner — paw print loading animation
 */
/**
 * @param {Object} props
 * @param {boolean} [props.fullPage] - Center vertically in viewport
 * @param {string} [props.message] - Optional loading message
 */
const LoadingSpinner = ({ fullPage = false, message }) => {
  const className = `loading-spinner${fullPage ? ' loading-spinner--full-page' : ''}`;
  const Tag = fullPage ? 'main' : 'div';

  return (
    <Tag className={className} role="status" aria-label="Loading">
      {fullPage && <img src="/logo.svg" alt="Thrive Companions" className="loading-spinner__logo" />}
      {fullPage && <h1 className="sr-only">Loading</h1>}
      <div className="loading-paws">
        <span className="loading-paws__paw loading-paws__paw--1"><img src="/paw.svg" alt="" width={28} height={28} /></span>
        <span className="loading-paws__paw loading-paws__paw--2"><img src="/paw.svg" alt="" width={28} height={28} /></span>
        <span className="loading-paws__paw loading-paws__paw--3"><img src="/paw.svg" alt="" width={28} height={28} /></span>
        <span className="loading-paws__paw loading-paws__paw--4"><img src="/paw.svg" alt="" width={28} height={28} /></span>
      </div>
      {message && <p className="loading-spinner__message">{message}</p>}
    </Tag>
  );
};

export default LoadingSpinner;
